import {
    apiRequest,
    mertuaCreate,
    masterRegion
} from "../../../../../../services/adapters/kepegawaian/mertuaService"

class CreateRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityDistrict = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityVillage= async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", mertuaCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository